import { z } from 'zod'

export const JudicialVolunteerSearchFormZod = z.object({
  volunteerCode: z.string().min(1, { message: 'field.required' }).optional().default(''),
})

export type JudicialVolunteerSearchFormData = z.infer<typeof JudicialVolunteerSearchFormZod>
